//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  name: 'NewsList',
  props: {
    pageSize: { type: Number, default: 10 },
    type: { type: String, default: 'personal' },
  },
  data() {
    return {
      dataList: [],
      statusMenu: [
        { label: '最新', value: null },
        { label: '系統', value: 0 },
        { label: '面試訊息', value: 1 },
      ],
      statusMenuActive: 0,
      status: null,
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters('user', ['token']),
    isEmptyData() {
      return isEmpty(this.dataList);
    },
    filterData() {
      if (this.status !== null) {
        return this.dataList.filter(item => {
          return item.type === this.status;
        });
      }
      return this.dataList;
    },
    url() {
      switch (this.type) {
        case 'owner':
          return '/Owner/Manage?tab=message';
        case 'lecturer':
          return '/Training/Manage?tab=message';
        case 'personal':
        default:
          return '/Personal?tab=message';
      }
    },
    getListApi() {
      switch (this.type) {
        case 'owner':
          return 'getOwnerMessage';
        case 'lecturer':
          return 'getLecturerMessage';
        case 'personal':
        default:
          return 'getUserMessage';
      }
    },
  },
  methods: {
    onStatusMenuClick(index, value) {
      this.status = value;
      this.statusMenuActive = index;
    },
    onClickItem(mid) {
      if (mid) this.$router.push(`${this.url}&mid=${mid}`);
    },
    getMessageList() {
      if (this.token) {
        this.$api(this.getListApi)
          .then(data => {
            this.dataList = data.records;
            this.status = null;
            this.statusMenuActive = 0;
          })
          .catch(() => {
            setTimeout(() => {
              this.getMessageList();
            }, 500);
          });
      }
    },
  },
  mounted() {
    this.getMessageList();
  },
};
